import { render, staticRenderFns } from "./UrgentNotificationSlide.vue?vue&type=template&id=e68523f4&scoped=true&"
import script from "./UrgentNotificationSlide.vue?vue&type=script&lang=js&"
export * from "./UrgentNotificationSlide.vue?vue&type=script&lang=js&"
import style0 from "./UrgentNotificationSlide.vue?vue&type=style&index=0&id=e68523f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68523f4",
  null
  
)

export default component.exports